import React from "react";

const PatientShimmer = () => {
  return <div>i am in patient shimmmer</div>;
};

export default PatientShimmer;
